import { render, staticRenderFns } from "./JournalEntriesList.vue?vue&type=template&id=536d60be"
import script from "./JournalEntriesList.vue?vue&type=script&lang=js"
export * from "./JournalEntriesList.vue?vue&type=script&lang=js"
import style0 from "./JournalEntriesList.vue?vue&type=style&index=0&id=536d60be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports